import { useEffect, useState } from 'react'

import gpaLogo from '~/assets/img/gpaLogo.png'
import { getAvailablePlans } from '~/modules/sales/services'
import { PaymentPlan } from '~/modules/sales/types'

import { PlanOffer } from './components/PlanOffer'

export function Offers() {
  const [plans, setPlans] = useState<PaymentPlan[]>([])

  useEffect(() => {
    const abortController = new AbortController()
    getAvailablePlans(abortController).then((data) => {
      if (data) {
        setPlans(data)
      }
    })

    return () => {
      abortController.abort()
    }
  }, [])

  return (
    <div
      className='p-5 flex flex-col flex-1 overflow-y-auto bg-gpa-blue-50
      min-h-screen'
    >
      <div className='max-w-[860px] w-full mx-auto flex flex-col gap-4'>
        <img src={gpaLogo} alt='GPA' width={200} className='mx-auto' />
        <div className='flex justify-between items-center'>
          <h3 className='font-semibold'>Planos disponíveis</h3>
        </div>

        {plans.map((p) => (
          <PlanOffer key={p.id} data={p} />
        ))}
      </div>
    </div>
  )
}
